import { ChartConfig } from "@/components/ui/chart"

export const chartConfig = {

  // Billing chart config
  DENIED:                    {         label: "Denied",                    color: "hsl(var(--chart-4))" },
  APPROVED:                  {         label: "Approved",                  color: "hsl(var(--chart-1))" },
  PENDING:                   {         label: "Pending",                   color: "hsl(var(--chart-6))" },

  denied:                    {         label: "Denied",                    color: "hsl(var(--chart-4))" },
  paid:                      {         label: "Paid",                      color: "hsl(var(--chart-1))" },
  approved:                  {         label: "Approved",                  color: "hsl(var(--chart-1))" },
  pending:                   {         label: "Pending",                   color: "hsl(var(--chart-6))" },
  
  Paid:                      {         label: "Paid",                      color: "hsl(var(--chart-1))" },
  Partial:                   {         label: "Partial",                   color: "hsl(var(--chart-18))" },
  Unpaid:                    {         label: "Unpaid",                    color: "hsl(var(--chart-2))" },
  paid_bills:                {         label: "Paid",                      color: "hsl(var(--chart-1))" },
  partial_bills:             {         label: "Partial",                   color: "hsl(var(--chart-18))" },
  unpaid_bills:              {         label: "Unpaid",                    color: "hsl(var(--chart-2))" },
  
  consumption:               {         label: "Consumption",              color: "hsl(var(--chart-10))" },
  "Payments Done":           {         label: "Payments Done",            color: "hsl(var(--chart-13))" },
  "Payments Pending":        {         label: "Payments Pending",         color: "hsl(var(--chart-16))" },

   // Meter chart config
  "Active Meters":           {         label: "Active Meters",            color: "hsl(var(--chart-2))" },
  "Inactive Meters":         {         label: "Inactive Meters",          color: "hsl(var(--chart-2))" },
  "Decommissioned Meters":   {         label: "Decommissioned Meters",    color: "hsl(var(--chart-8))" },
  "Unassigned Meters":       {         label: "Unassigned Meters",        color: "hsl(var(--chart-9))" },
  Active:                    {         label: "Active Meters",            color: "hsl(var(--chart-1))" },
  Inactive:                  {         label: "Inactive Meters",          color: "hsl(var(--chart-2))" },
  Decommissioned:            {         label: "Decommissioned Meters",    color: "hsl(var(--chart-5))" },
  Unassigned:              {         label: "Unassigned Meters",        color: "hsl(var(--chart-9))" },
  y:                         {         label: "Percentage",               color: "#FFFFFF" },
  NaN:                       {         label: "No data",                  color: "#FFFFFF" },
  active_count:              {         label: "Active",                   color: "hsl(var(--chart-1))" },
  inactive_count:            {         label: "Inactive",                 color: "hsl(var(--chart-2))" },
  decommissioned_count:      {         label: "Decommissioned",           color: "hsl(var(--chart-8))" },
  unassigned_count:          {         label: "Unassigned",               color: "hsl(var(--chart-9))" },
  data:                      {         label: "Count",                    color: "hsl(var(--default))" },

  //  Analytics chart config
  Residential:               {         label: "Residential",              color: "hsl(var(--chart-13))" },
  Commercial:                {         label: "Commercial",               color: "hsl(var(--chart-14))" },
  Government:                {         label: "Government",               color: "hsl(var(--chart-15))" },
  //  Analytics chart config
  residential:               {         label: "Residential",              color: "hsl(var(--chart-13))" },
  commercial:                {         label: "Commercial",               color: "hsl(var(--chart-14))" },
  government:                {         label: "Government",               color: "hsl(var(--chart-15))" },
  GovernmentA:               {         label: "Government A",             color: "hsl(var(--chart-16))" },
  "Government A":            {         label: "Government A",             color: "hsl(var(--chart-16))" },
  CommercialA:               {         label: "Commercial A",             color: "hsl(var(--chart-17))" },
  CommercialB:               {         label: "Commercial B",             color: "hsl(var(--chart-18))" },
  "Commercial A":            {         label: "Commercial A",             color: "hsl(var(--chart-17))" },
  "Commercial B":            {         label: "Commercial B",             color: "hsl(var(--chart-18))" },
  "test type":               {         label: "  test type",              color: "hsl(var(--default))" },
  total_current_consumption: {         label: "Total Current Consumption",color: "hsl(var(--default))" },
  amount:                    {         label: "Amount",                   color: "hsl(var(--default))" },
} satisfies ChartConfig



// chart config for manage consumer analytics
export const consumerChartConfig = {
  active:           { label: "Active Consumers",           color: "hsl(var(--chart-1))" },
  inactive:         { label: "Inactive Consumers",         color: "hsl(var(--chart-2))" },
  delinquent:       { label: "Delinquent Consumers",       color: "hsl(var(--chart-3))" },
  disconnected:     { label: "Disconnected Consumers",     color: "hsl(var(--chart-4))" },
  decommisioned:    { label: "Decommissioned Consumers",   color: "hsl(var(--chart-5))" },
  pending:          { label: "Pending Consumers",          color: "hsl(var(--chart-6))" },
  statustest:       { label: "Status Test Consumers",      color: "hsl(var(--chart-7))" },
  "status test":    { label: "Status Test Consumers",      color: "hsl(var(--default))" },


  Active:           { label: "Active Consumers",           color: "hsl(var(--chart-1))" },
  Inactive:         { label: "Inactive Consumers",         color: "hsl(var(--chart-2))" },
  Delinquent:       { label: "Delinquent Consumers",       color: "hsl(var(--chart-3))" },
  Disconnected:     { label: "Disconnected Consumers",     color: "hsl(var(--chart-4))" },
  Decommisioned:    { label: "Decommissioned Consumers",   color: "hsl(var(--chart-5))" },
  Pending:          { label: "Pending Consumers",          color: "hsl(var(--chart-6))" },
  Statustest:       { label: "Status Test Consumers",      color: "hsl(var(--chart-7))" },
  "Status test":    { label: "Status Test Consumers",      color: "hsl(var(--default))" },
} satisfies ChartConfig


export const meterChartConfig = {
  active:          { label: "Active Meters",           color: "hsl(var(--chart-1))" },
  inactive:        { label: "Inactive Meters",         color: "hsl(var(--chart-2))" },
  decommissioned:  { label: "Decommissioned Meters",   color: "hsl(var(--chart-5))" },
  unassigned:      { label: "Unassigned Meters",       color: "hsl(var(--chart-9))" },
  Total:           { label: "Total Meters",            color: "hsl(var(--default))" },
} satisfies ChartConfig

